export default "__VITE_ASSET__CH4kUNP1__"